import { all } from 'redux-saga/effects'
import { selectsSaga } from './selects/saga'

export function* staticSaga() {
  yield all([selectsSaga()])
}
